import { useTypedSelector } from '../../../shared/hooks';
import { type RootState } from '../../../shared/types';
import { isSupportedGlobalDateFormatKey } from '../utils/utils';

/**
 * Returns the effective date format for AuditLogViewer.
 * Uses ecmDateFormat (from header preferences API) as the source of truth when available.
 * Falls back to globalDateFormat when ecmDateFormat is not yet loaded (e.g. initial load).
 *
 * This bypasses the sync from routes.tsx so components always reflect the latest value
 * when ecmDateFormat changes (initial load or user settings).
 */
export default function useDateFormat(): string | undefined {
  const ecmDateFormat = useTypedSelector((s: RootState) => {
    const menu = s.user.headerMenu;

    return typeof menu.ecmDateFormat === 'string'
      ? menu.ecmDateFormat
      : undefined;
  });

  const globalDateFormat = useTypedSelector(
    (s: RootState) => s.aag.global.globalDateFormat
  );

  if (isSupportedGlobalDateFormatKey(ecmDateFormat)) {
    return ecmDateFormat;
  }

  if (isSupportedGlobalDateFormatKey(globalDateFormat)) {
    return globalDateFormat;
  }

  return ecmDateFormat && ecmDateFormat.length > 0
    ? ecmDateFormat
    : globalDateFormat;
}
